module.exports = __webpack_public_path__ + "img/Frame 751.ba722f96.png";